import { Webhooks } from 'features/webhooks';

export const TechOperatorWebhooksPage: React.FC = () => <Webhooks />;
